export default __webpack_public_path__ + "static/media/a011-market-5.606d3949.svg";